import { useEffect, useState, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Typography } from '@mui/material';
import { Calendar } from 'primereact/calendar';
import { AutoComplete } from 'primereact/autocomplete';
import { Menu, MenuMenu } from 'semantic-ui-react';
import { connect } from 'react-redux';
import Button from '@mui/material/Button';
import "primereact/resources/themes/lara-light-indigo/theme.css";

import classes from './classes.module.scss';

import {
    getAccounts
} from 'app/services/accounts';

import {
    getWorkerStatusReport
} from 'app/services/reports'

import {
    formatOptions
} from 'app/utils/options';

import {
    formatCurrency
} from 'app/utils/valueFormatters';

const DailyReadReport = (props) => {
    const [loaded, setLoaded] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [filteredAccounts, setFilteredAccounts] = useState([]);
    const [details, setDetails] = useState([]);
    const [summary, setSummary] = useState([]);
    const [polling, setPolling] = useState(true);
    const pollingRef = useRef()

    pollingRef.current = polling;

    const defaultEndDate = new Date()
    const defaultStartDate = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000)

    function refresh() {
        console.log("Polling");
        if (!pollingRef.current) {
            console.log("Done Polling")
            return
        }

        setLoaded(false);
        setTimeout(refresh, 3000);
    }

  useEffect(() => {
    return () => {
        setPolling(false);
        pollingRef.current = false;
        console.log("Turning off polling during unmount")
    };
  }, []);

    useEffect(() => {
        if (!loaded) {
            if (!startDate && !endDate) {
                setEndDate(defaultEndDate);
                setStartDate(defaultStartDate);
                setTimeout(refresh, 3000);
            }

            getWorkerStatusReport({ start_date: startDate || defaultStartDate, end_date: endDate || defaultEndDate }).then((result) => {
                setDetails(result.worker_status_detailed);
                setSummary(result.worker_status_summary);
            }).catch((resp) => {
                console.log(resp);
            })

            setLoaded(true);
        }
    }, [loaded])

    // const getAccountOptions = async (page = 1, perPage = 100, filter = null) => {
    //     let params = {
    //         page,
    //         per_page: perPage
    //     }

    //     if (filter) {
    //         params.filter_model = {
    //             name: [{
    //                 filterClass: 'text',
    //                 filterType: 'contains',
    //                 value: filter
    //             }]
    //         }
    //     }

    //     let resp = await getAccounts(params);
    //     return formatOptions(resp.records);
    // }

    // const searchAccounts = (e) => {
    //     const selected = e.query;

    //     if (!selected) {
    //         getAccountOptions().then(recs => {
    //             setFilteredAccounts(recs);
    //         });
    //     }

    //     if (selected) {
    //         getAccountOptions(1, 100, selected).then(recs => {
    //             setFilteredAccounts(recs);
    //         });
    //     }
    // }

    const handleDateChanged = (dateType, dateValue) => {
        if (dateType === 'start_date') {
            setStartDate(dateValue);
        } else {
            setEndDate(dateValue);
        }
        setPolling(false);
        setLoaded(false);
    }

    let sx = { margin: '0 0.5rem' };

    const header = (
        <div>
            <div className={classes.toolbar}>
                <Menu stackable secondary fluid>
                    <Menu.Item>
                        <Typography variant="h1">
                            Worker Status Report
                        </Typography>
                    </Menu.Item>

                    <MenuMenu position='right'>
                        <Menu.Item>
                            <Calendar id="start_date" placeholder='Start Date' value={startDate} onChange={(e) => handleDateChanged('start_date', e.value)} showIcon />
                        </Menu.Item>
                        <Menu.Item>
                            <Calendar id="end_date" placeholder='End Date' value={endDate} onChange={(e) => handleDateChanged('end_date', e.value)} showIcon />
                        </Menu.Item>
                    </MenuMenu>
                </Menu>
            </div>
        </div>
    );

    return <div>
        {header}
        <DataTable size="small" value={summary} className={classes.datatable} stripedRows scrollable scrollHeight="20vh">
            <Column field='job_name' header="Job" />
            <Column field='queued' header="Queued" />
            <Column field='in_progress' header="In Progress" />
            <Column field='completed' header="Completed" />
            <Column field='failed' header="Failed" />
        </DataTable>
        <br />
        <DataTable size="small" value={details} className={classes.datatable} stripedRows scrollable scrollHeight="60vh">
            <Column field='hour' header="Hour" />
            <Column field='job_name' header="Job" />
            <Column field='num_jobs' header="Count" />
            <Column field='avg_queued' header="Avg Queued" />
            <Column field='avg_seconds' header="Avg Seconds" />
            <Column field='max_queued' header="Max Queued" />
            <Column field='max_seconds' header="Max Seconds" />
        </DataTable>
    </div>
}

const mapStateToProps = state => ({
    account: state.portalReducer.account
});

export default connect(mapStateToProps, {})(DailyReadReport);